import {
  CategoryScale,
  Chart,
  Legend,
  LinearScale,
  PointElement,
  ScatterController,
  Tooltip,
} from "chart.js";
import React, { useEffect, useRef } from "react";

Chart.register(
  ScatterController,
  LinearScale,
  CategoryScale,
  PointElement,
  Tooltip,
  Legend
);

const OrderGraph = () => {
  const chartRef = useRef(null);
  let chartInstance = null;

  useEffect(() => {
    const ctx = chartRef.current.getContext("2d");

    if (chartInstance) chartInstance.destroy();

    chartInstance = new Chart(ctx, {
      type: "scatter",
      data: {
        datasets: [
          {
            label: "Item A",
            data: [{ x: "Item A", y: 1200 }],
            backgroundColor: "red",
            pointRadius: 5,
          },
          {
            label: "Item B",
            data: [{ x: "Item B", y: 900 }],
            backgroundColor: "blue",
            pointRadius: 5,
          },
          {
            label: "Item C",
            data: [{ x: "Item C", y: 700 }],
            backgroundColor: "green",
            pointRadius: 5,
          },
          {
            label: "Item D",
            data: [{ x: "Item D", y: 1400 }],
            backgroundColor: "purple",
            pointRadius: 5,
          },
          {
            label: "Item E",
            data: [{ x: "Item E", y: 500 }],
            backgroundColor: "orange",
            pointRadius: 5,
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: { usePointStyle: true, mx: 1, my: 4, boxWidth: 280 },
          },
        },
        scales: {
          x: {
            type: "category",
            title: { display: true, text: "Items" },
          },
          y: {
            beginAtZero: true,
            title: { display: true, text: "Monthly Spend (₹)" },
          },
        },
      },
    });

    return () => chartInstance?.destroy();
  }, []);

  return (
    <div style={{ width: "900px", margin: "30px auto" }}>
      <h2
        style={{
          textAlign: "center",
          marginBottom: "10px",
          fontWeight: "600",
        }}
      >
        Monthly Spend Overview
      </h2>
      <canvas ref={chartRef} height="200" style={{ backgroundColor: 'white', py: 5, px: 5 }}></canvas>
    </div>
  );
};

export default OrderGraph;
